import { useFormContext } from 'react-hook-form';
import useAppModal from 'hooks/useAppModal';
import { PropertySettingsMainTabFormValues } from '../../PropertySettingsMainTab.schema';
import { AirbnbSettings } from '../../PropertySettingsMainTab.types';
import SetInstructionsModal from './SetInstructionsModal';

const setInstructionsModalId = 'set-instructions-modal-id';

const useSetInstructionsModal = () => {
  const { openModal, closeModal } = useAppModal();
  const { getValues, setValue } =
    useFormContext<PropertySettingsMainTabFormValues>();

  const handleOnSubmit = ({
    checkInOptionInstruction,
  }: Pick<AirbnbSettings, 'checkInOptionInstruction'>) => {
    setValue(
      'airbnbSettings.checkInOptionInstruction',
      checkInOptionInstruction,
      {
        shouldDirty: true,
      },
    );
    closeModal(setInstructionsModalId);
  };

  const openSetInstructionsModal = () => {
    openModal({
      customContent: (
        <SetInstructionsModal
          defaultValues={{
            checkInOptionInstruction: getValues(
              'airbnbSettings.checkInOptionInstruction',
            ),
          }}
          onSubmit={handleOnSubmit}
        />
      ),
      id: setInstructionsModalId,
      size: 'medium',
    });
  };

  return {
    openSetInstructionsModal,
  };
};

export default useSetInstructionsModal;
